var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "gallery-feed-view-toggle" }, [
    _c(
      "label",
      {
        staticClass: "gallery-feed-view-toggle__label",
        attrs: { id: "feedCheckboxLabel", for: "feedViewCheckbox" },
      },
      [
        _c("span", { staticClass: "sr-only" }, [
          _vm._v(_vm._s(_vm.labels.layoutMode)),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "gallery-feed-view-toggle__button",
        attrs: {
          "aria-labelledby": "feedCheckboxLabel",
          id: "feedViewCheckbox",
          role: "radiogroup",
        },
      },
      [
        _c("span", { staticClass: "switch" }, [
          _c("span", {
            staticClass: "feed",
            class: { active: _vm.layoutMode == "feed" },
            attrs: {
              "aria-hidden": "false",
              role: "radio",
              tabindex: "0",
              "aria-checked": _vm.layoutMode == "feed" ? "true" : "false",
              title: _vm.labels.layoutModeFeedTitle,
              "aria-label": _vm.labels.layoutModeFeed,
            },
            on: {
              keydown: _vm.onSwitchKeyDown,
              click: function ($event) {
                return _vm.updateLayoutMode("feed")
              },
            },
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "grid",
            class: { active: _vm.layoutMode == "grid" },
            attrs: {
              "aria-hidden": "false",
              role: "radio",
              tabindex: "0",
              "aria-checked": _vm.layoutMode == "grid" ? "true" : "false",
              title: _vm.labels.layoutModeGridTitle,
              "aria-label": _vm.labels.layoutModeGrid,
            },
            on: {
              keydown: _vm.onSwitchKeyDown,
              click: function ($event) {
                return _vm.updateLayoutMode("grid")
              },
            },
          }),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }